module.exports = __webpack_public_path__ + "img/gl5.f2e4deaf.jpg";